import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import ResultsSection from './components/ResultsSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="font-inter">
      <Navbar />
      <main>
        <Hero />
        <ProblemSection />
        <SolutionSection />
        <ServicesSection />
        <IndustriesSection />
        <ResultsSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
